import type { MenuCategory as MenuCategoryType } from "../lib/menuTypes";
import { MenuItemCard } from "./MenuItemCard";

type MenuCategoryProps = {
  category: MenuCategoryType;
  displayMode?: boolean;
};

export function MenuCategory({ category, displayMode = false }: MenuCategoryProps) {
  if (category.items.length === 0) return null;

  const categorySlug = category.name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
  const className = [
    "menu-category",
    displayMode ? "menu-category--display" : "",
    displayMode && category.items.length >= 3 ? "menu-category--wide" : "",
    displayMode ? `menu-category--${categorySlug}` : ""
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <section className={className}>
      <div className="menu-category__header">
        <h2>{category.name}</h2>
      </div>
      <div className="menu-grid">
        {category.items.map((item) => (
          <MenuItemCard item={item} displayMode={displayMode} key={item.id} />
        ))}
      </div>
    </section>
  );
}
